var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8283 2.49927H4.1654C3.24522 2.49927 2.49927 3.24522 2.49927 4.1654V15.8283C2.49927 16.7485 3.24522 17.4945 4.1654 17.4945H15.8283C16.7485 17.4945 17.4945 16.7485 17.4945 15.8283V4.1654C17.4945 3.24522 16.7485 2.49927 15.8283 2.49927Z",
    stroke: "#F0E1CE",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49768 9.16381C8.41786 9.16381 9.16381 8.41786 9.16381 7.49768C9.16381 6.5775 8.41786 5.83154 7.49768 5.83154C6.5775 5.83154 5.83154 6.5775 5.83154 7.49768C5.83154 8.41786 6.5775 9.16381 7.49768 9.16381Z",
    stroke: "#F0E1CE",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4943 12.4959L14.9234 9.92508C14.611 9.61272 14.1873 9.43726 13.7455 9.43726C13.3037 9.43726 12.88 9.61272 12.5675 9.92508L4.99829 17.4943",
    stroke: "#F0E1CE",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon06);
export default __webpack_public_path__ + "static/media/icon06.bcc2d88928a4bfdc1dbbfd584ed098b8.svg";
export { ForwardRef as ReactComponent };